import { render } from "./PosMovementsPage.vue?vue&type=template&id=067db8ab"
import script from "./PosMovementsPage.vue?vue&type=script&lang=js"
export * from "./PosMovementsPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3657311707/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__